import { BaseProvider } from "./base.provider";
import { event } from "../utilities/event-listeners";
export class GoldenraceProvider extends BaseProvider {
    messageHandler(e) {
        switch (e.data.action) {
            case "game.loaded": // Game successfully loaded.
                break;
            case "game.balance.changed":
                // homePage.RefreshCashBalance();
                break;
            case "game.cycle.started": // Ticket placing...
                break;
            case "game.cycle.end": // Ticket placed
                break;
            case "game.goto.home": // Game has to be redirected to the home lobby page.(exit)
                break;
            case "game.goto.history":
                break;
            case "game.resize.height":
                // TODO: event system
                // commenting out for now
                // this.$emit("resize-iframe", { height: e.data.value });
                window.dispatchEvent(event({
                    detail: { height: parseInt(e.data.value.replace("px", "")) },
                }));
                break;
            case "game.get.clientrect":
                // TODO: element id operator
                // commenting out for now
                e.source.postMessage({
                    action: "game.clientrect",
                    value: document
                        .getElementById("lobby_game")
                        .getBoundingClientRect(),
                }, "*");
                break;
            case "game.get.clientheight":
                // TODO: element id operator
                // commenting out for now
                e.source.postMessage({
                    action: "game.clientheight",
                    value: document.getElementById("lobby_game").offsetHeight,
                }, "*");
                break;
            case "game.get.innerheight":
                e.source.postMessage({ action: "game.innerheight", value: window.innerHeight }, "*");
                break;
        }
    }
    init() {
        window.addEventListener("message", this.messageHandler, true);
        window.addEventListener("beforeunload", () => window.removeEventListener("message", this.messageHandler, true));
    }
}
